<template>
  <div class='my_move'>
    <div>
      <span>旋转度数</span>
      <el-input-number class='width50' :controls='false' size="mini" :min="-180" :max="180" v-model="backgroundDeg"
        @blur='change'></el-input-number>
    </div>

    <div>
      <div class='gradx_panel' v-bind:style='{ background: background }'></div>
      <div class='gradx_start_sliders'>
        <div class='gradx_slider' :style='{ background: color1 }' @mousedown.self="move($event, 1)">
          <el-color-picker v-model="color1" size="mini" @change='change'></el-color-picker>
        </div>
        <div class='gradx_slider gradx_slider2' :style='{ background: color2 }' @mousedown.self="move($event, 2)">
          <el-color-picker v-model="color2" size="mini" @change='change'></el-color-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'move',
  props: ['backgroundColor', 'compatible_style'],
  data() {
    return {
      color1: '#ccc',
      left1: '20%',
      background: this.backgroundColor,
      backgroundDeg: 0,
      color2: '#000',
      left2: '70%'
    }
  },
  mounted() {
    if (this.background) {
      const arr = this.background.match(/\d+(?=deg)/) || []
      this.backgroundDeg = arr[0] || 0
      this.color1 = this.background.slice(this.background.indexOf('#'), this.background.indexOf('#') + 7)
      this.color2 = this.background.slice(this.background.lastIndexOf('#'), this.background.lastIndexOf('#') + 7)
    }
  },
  methods: {
    move(e, num) {
      let odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        // let top = e.clientY - disY;

        //移动当前元素
        if (left < 0) {
          odiv.style.left = '0px';
          left = 0
        } else if (left > 200) {
          odiv.style.left = '200px';
          left = 200
        } else {
          odiv.style.left = left + 'px';
        }
        this['left' + num] = left / 2 + '%'
        this.change()
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    change() {
      console.log(111)
      if (!this.color1) {
        this.color1 = '#fff'
      }
      if (!this.color2) {
        this.color1 = '#fff'
      }
      this.background = `${this.compatible_style}linear-gradient(${this.backgroundDeg}deg, ${this.color1} ${this.left1}, ${this.color2} ${this.left2})`
      this.$emit('moveColor', this.background)
    },
  }
}
</script>
<style lang="less" scoped>
.my_move {
  margin-bottom: 30px;
  display: flex;
}

.gradx_panel {
  width: 200px;
  height: 42px;
  margin-left: 5px // background:#3388ff;
}

.gradx_start_sliders {
  width: 210px;
  margin-top: 8px;
  background: whitesmoke;
  height: 12px;
  box-shadow: 5px 9px 30px rgba(0, 0, 0, .5) inset;
  -webkit-box-shadow: 5px 9px 30px rgba(0, 0, 0, .5) inset;
  -moz-box-shadow: 5px 9px 30px rgba(0, 0, 0, .5) inset;
  -o-box-shadow: 5px 9px 30px rgba(0, 0, 0, .5) inset;
  border: 1px solid #f1f1f1;
  position: relative
}

.gradx_slider {
  position: absolute;
  left: 40px;
  width: 10px;
  height: 10px;
  border: 1px solid black;
  display: inline-block;
  opacity: 0.6;
}

.gradx_slider:after {
  content: "";
  position: absolute;
  bottom: 10px;
  left: 4px;
  border-style: solid;
  border-width: 70px 1px 0px 0px;
  border-color: transparent #000;
  display: block;
  width: 0;
  z-index: 1;
}

.gradx_slider2 {
  left: 140px
}

/deep/ .el-color-picker--mini .el-color-picker__trigger {
  position: absolute;
  top: 12px;
}

.width50 {
  width: 50px;
  margin-right: 10px
}
</style>